<template>
  <div class="tw-border tw-border-gray-200 sm:tw-rounded-lg tw-text-gray-700 tw-font-normal tw-text-sm" :class="overflowClass">
    <table class="tw-min-w-full tw-divide-y tw-divide-gray-200">
      <thead>
        <tr class="tw-border-b tw-border-gray-200">
          <th
            v-for="field in fields"
            :key="field.key"
            :class="['tw-font-medium tw-uppercase tw-text-gray-600 tw-text-xs tw-tracking-wide tw-text-left tw-py-2 tw-bg-gray-100 tw-px-4 tw-whitespace-no-wrap', field.thClass]"
            @click="(field.isSortable && handleHeaderClick(field)) || (field.onClick && field.onClick())"
          >
            <div v-if="field.hasOwnProperty('isCheckbox')">
              <base-checkbox :value="field.key" v-model="headerCheckValue" @input="emitChecked" />
            </div>
            <div v-else :class="['tw-inline-flex tw-items-center', { 'tw-underline tw-cursor-pointer': field.isSortable }]">
              {{ field.title }}
              <div
                ref="button-tooltip-group"
                class="tw-group tw-relative tw-px-1 tw-py-2 tw-cursor-pointer"
                @mouseover="showTooltip(field.key)"
                @mouseout="hideTooltip(field.key)"
                v-if="field.tooltip"
              >
                <information-icon class="tw-flex-none tw-w-3 tw-h-3 tw-my-auto tw-text-gray-800 " />
                <base-tooltip :ref="'infoTooltip-' + field.key" :textValue="field.tooltip" />
              </div>
              <component class="tw-w-3.5 tw-h-3.5 tw-ml-1" v-if="sortKey === field.key" :is="sortDesc ? 'chevron-down-icon' : 'chevron-up-icon'" />
            </div>
          </th>
        </tr>
      </thead>
      <tbody v-if="loading" class="tw-bg-white">
        <tr :class="['tw-border-gray-200', { 'tw-border-b': key < computedLoadingRows }]" v-for="key in computedLoadingRows" :key="`loading-row-${key}`">
          <slot name="loading-row">
            <td v-for="field in fields" :key="field.key" :class="['tw-py-3 tw-px-4', field.tdClass]" :align="field.align">
              <slot name="loading-cell">
                <base-skeleton-loader class="tw-h-5 tw-w-full" />
              </slot>
            </td>
          </slot>
        </tr>
      </tbody>
      <tbody v-else class="tw-bg-white">
        <tr v-for="(item, index) in items" :key="index" :class="['tw-border-gray-200', { 'tw-border-b': index + 1 < items.length }]">
          <td
            v-for="field in fields"
            :key="`${index}-${field.key}`"
            :class="[
              'tw-py-3 tw-px-4',
              field.tdClass,
              { 'tw-rounded-bl-lg': index + 1 === items.length && field.key === fields[0].key },
              { 'tw-rounded-br-lg': index + 1 === items.length && field.key === fields[fields.length - 1].key },
            ]"
            :align="field.align"
          >
            <slot :item="item" :index="index" :name="field.key">{{ item[field.key] }}</slot>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-show="items && !items.length && !loading" class="tw-bg-white tw-w-full">
      <slot name="empty-state" />
    </div>
  </div>
</template>

<script>
import { ChevronDownIcon, ChevronUpIcon, InformationIcon } from "@/assets/svgs";

export default {
  components: {
    ChevronDownIcon,
    ChevronUpIcon,
    InformationIcon,
  },
  props: {
    loading: Boolean,
    fields: Array,
    items: Array,
    sortKey: String,
    sortDesc: Boolean,
    loadingRows: { type: Number, default: 3 },
    overflowVisible: { type: Boolean, default: false },
  },
  data() {
    return {
      headerCheckValue: [],
    };
  },
  computed: {
    overflowClass() {
      return this.overflowVisible ? "tw-overflow-visible" : "tw-overflow-auto";
    },
    computedLoadingRows() {
      if (this.items && this.items.length > 0) return this.items.length;
      else return this.loadingRows;
    },
  },
  methods: {
    handleHeaderClick(field) {
      this.$emit("update:sortDesc", this.sortKey === field.key ? !this.sortDesc : true);
      this.$emit("update:sortKey", field.key);
    },
    emitChecked() {
      this.$emit("checked", this.headerCheckValue);
    },
    clearChecked() {
      this.headerCheckValue = [];
    },
    showTooltip(key) {
      let index = "infoTooltip-" + key;
      this.$refs[index][0].show();
    },
    hideTooltip(key) {
      let index = "infoTooltip-" + key;
      this.$refs[index][0].hide();
    },
  },
};
</script>
